import React from "react";
import { Box, Grid, TextField, Button } from "@mui/material";

const SubtitleEditor = ({ value, onChange, disabled }) => {
    let subtitle = [];

    if (typeof value === "string") {
        try {
            subtitle = value ? JSON.parse(value) : [];
        } catch (e) {
            console.error("Subtitle parse error:", e);
            subtitle = [];
        }
    } else {
        subtitle = value || [];
    }
    const handleChange = (index, field, newValue) => {
        const updated = [...subtitle];
        updated[index] = { ...updated[index], [field]: newValue };
        onChange(JSON.stringify(updated)); // 🔹 string olarak gönder
    };

    const handleAddRow = () => {
        onChange(JSON.stringify([...subtitle, { start: 0, end: 0, text: "" }]));
    };

    const handleRemoveRow = (index) => {
        const filtered = subtitle.filter((_, i) => i !== index);
        onChange(filtered.length ? JSON.stringify(filtered) : ""); // 🔹 Boşsa "" gönder
    };

    return (
        <Box>
            <Box sx={{ maxHeight: 250, overflowY: "auto", mb: 1 }}>
                {subtitle.map((row, i) => (
                    <Grid container spacing={1} key={i} sx={{ mb: 1 }}>
                        <Grid item xs={3}>
                            <TextField
                                type="number"
                                size="small"
                                label="Start"
                                value={row.start}
                                onChange={(e) => handleChange(i, "start", parseFloat(e.target.value))}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                type="number"
                                size="small"
                                label="End"
                                value={row.end}
                                onChange={(e) => handleChange(i, "end", parseFloat(e.target.value))}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <TextField
                                size="small"
                                fullWidth
                                label="Text"
                                value={row.text}
                                onChange={(e) => handleChange(i, "text", e.target.value)}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Button onClick={() => handleRemoveRow(i)} disabled={disabled}>X</Button>
                        </Grid>
                    </Grid>
                ))}
            </Box>
            <Button onClick={handleAddRow} disabled={disabled}>+ Add Subtitle</Button>
        </Box>
    );
};

export default SubtitleEditor;
